<template>
  <!-- <ABackDrop > -->
  <div class="loading-wrap" v-if="commonStore.isLoading">
    <!-- :is-visible="commonStore.isLoading" -->
    <vue3-lottie
      ref="lottieContainer"
      :animation-data="loadingData"
      :width="200"
      :height="200"
    >
    </vue3-lottie>
  </div>
  <!-- </ABackDrop> -->
</template>
<script setup lang="ts">
// import { computed } from 'vue';
import loadingData from '@assets/img/loading.json';
// import { ABackDrop } from '@atoms';
import { useCommonStore } from '@stores';
import { Vue3Lottie } from 'vue3-lottie';

// interface Props {
//   type: 'loading' | 'payment';
//   isVisible: boolean;
// }

// props, emits
// const props = withDefaults(defineProps<Props>(), {
//   type: 'loading',
//   isVisible: false,
// });

// const loadingType = computed(() => {
//   return props.type === 'loading' ? loadingData : paymentLoadingData;
// });
const commonStore = useCommonStore();
</script>

<style scoped lang="scss">
.loading-wrap {
  @apply fixed flex items-center justify-center inset-0 w-full h-full;
  background-color: #383838;
  opacity: 0.5;
  z-index: 190;
}
</style>
